import { msalInstance, state } from "@/config/msalConfig";
import * as Sentry from '@sentry/vue'

export function useAuth() {
  async function login() {
    try {
      // Check if MSAL is initialized
      if (!msalInstance) {
        throw new Error('MSAL not initialized. Call initializeMsal() before using it.')
      }

      await msalInstance.loginRedirect()

      // IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise.
      // This function will navigate away from the current browser window.
      // It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
    } catch (error) {
      console.error('Login error', error)
    }
  }

  async function logout() {
    if (!msalInstance) {
      throw new Error('MSAL not initialized. Call initializeMsal() before using it.')
    }

    msalInstance.logoutRedirect()
  }

  async function handleRedirect() {
    try {
      await msalInstance.handleRedirectPromise()

      // Try to get cached accounts
      const accounts = msalInstance.getAllAccounts()

      // If no accounts are found, return to App.vue and it will start a login
      if (!accounts.length) {
        return
      }

      const user = accounts[0]

      state.isAuthenticated = !!user
      state.user = user

      // Set Sentry user
      Sentry.setUser({
        id: user.localAccountId,
        email: user.username,
        username: user.name,
      })

      // Heap
      if (window.heap.identify) {
        window.heap.identify(user.name)
      }
      
      if (window.heap.addUserProperties) {
        window.heap.addUserProperties({
          'Name': user.name,
          'Email': user.username,
          'Azure ID': user.localAccountId
        })
      }

      msalInstance.setActiveAccount(state.user)
    } catch (error) {
      console.error('Redirect error:', error)
    }
  }

  return { login, logout, handleRedirect }
}